import PropTypes from 'prop-types';
import React from 'react';
import Badge from '../../IDSBadge';

const RegionalHighlightTextBlock = ({ regionalContent, translation }) => {
  const regionName = regionalContent[0]?.CurrentRegionName;
  const langLabel = (translation || 'Innehållet gäller') + ' ' + regionName;

  return regionalContent?.some((e) => e.Content) ? (
    <div className="c-highlight__text-container__regional-container">
      <Badge type={'secondary'} text={langLabel} />
      {regionalContent.map((block, index) => {
        return <p key={index}>{block.Content}</p>;
      })}
    </div>
  ) : (
    ''
  );
};

RegionalHighlightTextBlock.propTypes = {
  regionalContent: PropTypes.array,
};

export default RegionalHighlightTextBlock;
